export default __webpack_public_path__ + "static/media/illustration-algostudy-n-m@3x.2779a1bb.webp";